import React, { useEffect, useState } from 'react' 
import queryString from 'query-string'
import { getRecomendations, getTopData } from 'API/API.service';
import './App.scss';
import AppMain from 'Components/AppMain/AppMain';
import { initialDummyData } from 'API/initialDummyData';
import Landing from 'Components/Landing/Landing';
import { getGenreArray } from 'Utils/getGenreArray';

const App = () => {

  const [ serverData, setServerData ] = useState(null) 
  const { access_token } = queryString.parse(window.location.search)

  const getServerData = async () => {
    const artists = await getTopData(access_token, 'artists', 'long_term');
    const tracks = await getTopData(access_token, 'tracks', 'long_term');

    if(artists.error||tracks.error){
      setServerData({ serverError:"artists.error || tracks.error" })
      return window.location= "https://spotify-top-21.vercel.app/"
    }

    const recommendations = artists.error ? [] : await getRecomendations(getGenreArray(artists), access_token)
    setServerData({...serverData, tracks, artists, recommendations })
  }


  useEffect(()=>{ if(access_token){ getServerData() } },[])

  return (
    <div className="App">
      { 
        !serverData ?   
          <Landing dummyData={initialDummyData} serverData={serverData} />
        :

          <AppMain serverData={serverData} />
      } 
    </div>
  );
}

export default App;
